// extracted by mini-css-extract-plugin
module.exports = {"container":"BprSectionEditor_container_2Qcw7","btnAddNew__withMarginTop":"BprSectionEditor_btnAddNew__withMarginTop_3NVKk","spinAround":"BprSectionEditor_spinAround_Zdgxe"};